export class FeatureModel {
    id:number;
    imageName:string;
    title:string;
    link:string;
}